import ProxyBase from '../../../../core/proxies/ProxyBase'

class ScreeningProxy extends ProxyBase {
  getScreeningIndicators(params) {
    return this.get('SmartScreening/indicators', params)
  }

  getVSIC(params) {
    return this.get('Category/VSIC', params)
  }

  getICB(params) {
    return this.get('Category/ICB', params)
  }

  getTotalResult(params) {
    return this.post('SmartScreening/count', params)
  }

  getYearReports(params) {
    return this.get('Setting/YearReports', params)
  }

  getVietnameseLocation(params) {
    return this.get('Category/VietnameseLocation', params)
  }

  getCompanyStatus(params) {
    return this.get('Category/ActiveStatus', params, undefined, true)
  }

  getLegalForm(params) {
    return this.get('Category/legalForm', params)
  }

  getCompanyType(params) {
    return this.get('Category/companyType', params)
  }

  getSuggestData(path, params) {
    return this.get(path, params)
  }

  getScreeningPrice(params) {
    return this.get('Report/ScreeningPrice', params)
  }

  exportFile(params) {
    return this.post('SmartScreening/export', params, {}, 'download')
  }

  saveCriteria(params) {
    return this.post('SmartScreening/SaveCriteria', params)
  }

  getSavedCriterias(params) {
    return this.get('SmartScreening/SavedCriterias', params)
  }

  getSavedCriteria(params) {
    return this.get('SmartScreening/SavedCriteria', params)
  }

  deleteSavedCriteria(params) {
    return this.delete('SmartScreening/SavedCriteria', params)
  }

  getVoucher(params) {
    return this.get('DiscountAndVoucher/Voucher', params)
  }

  getListingStatus(params) {
    return this.get('Category/ListingStatus', params)
  }
}

export default new ScreeningProxy()
